import {UntypedFormControl} from '@angular/forms';
import {DateTime} from 'luxon';

export function timezoneValidator(control: UntypedFormControl): {[key: string]: any} | null {
  if (control.value) {

    const rezoned = DateTime.local().setZone(control.value);
    if (!rezoned.isValid) {
      return { invalidTimezone: true };
    }
  }

  return null
}
